﻿import { Coordinate } from './Types';

export const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

// Returns the angle at point c1
export const angle = (c1: Coordinate, c2: Coordinate, c3: Coordinate) => {
  const a = euclideanDistance(c2, c3);
  const b = euclideanDistance(c1, c3);
  const c = euclideanDistance(c1, c2);

  const rightSide = 2 * b * c !== 0 ? 2 * b * c : 1;

  const A = ((b ** 2) + (c ** 2) - (a ** 2)) / rightSide;

  const angle = Math.acos(A);
  return (angle * (180 / Math.PI));
};

export const euclideanDistance = (c1: Coordinate, c2: Coordinate) => {
  return Math.sqrt(Math.pow(c1.x - c2.x, 2) + Math.pow(c1.y - c2.y, 2));
};